import *  as joint from '../rappid/rappid.min.js'

export const layoutGraph = (graph, layoutParam) => {
  const options = {
    nodeSep: Number(layoutParam.nodeStep),
    edgeSep: Number(layoutParam.edgeSep),
    rankDir: layoutParam.rankDir
  }
  joint.layout.DirectedGraph.layout(graph, options);
}